import { format } from 'date-fns';

/**
 * Format a Date as an ISO date string (yyyy-MM-dd) for API payloads.
 * Used for case closure dates and other date fields sent to NorthStar.
 *
 * @param date - the date to format
 * @returns the formatted date string
 * @example
 * ```ts
 * formatCaseDate(new Date('2026-03-09')); // '2026-03-09'
 * ```
 */
export function formatCaseDate(date: Date): string {
    return format(date, 'yyyy-MM-dd');
}

/**
 * Concatenate a first and last name into a single string. Returns a trimmed result, so missing
 * parts do not leave leading or trailing whitespace.
 *
 * @param firstName - the person's first name (may be empty)
 * @param lastName - the person's last name (may be empty)
 * @returns the combined full name, trimmed
 * @example
 * ```ts
 * formatFullName('Luke', 'Chavers'); // 'Luke Chavers'
 * formatFullName('', 'Chavers');     // 'Chavers'
 * ```
 */
export function formatFullName(firstName: string, lastName: string): string {
    return `${firstName} ${lastName}`.trim();
}
